import { featureFlags } from '@shared-services/feature-flags';
import CustomizationsState from 'client/widget-components/ecom/stores/CustomizationsState';
import { Customization } from 'client/widget-components/ecom/stores/types';
import { CustomizationType } from 'client/widget-components/ecom/types/EcomSDK';
import { observer } from 'mobx-react';
import React from 'react';
import type { PCFileStackConfig, ProductCustomizationsStyles } from '../types';
import { CheckboxCustomization } from './CheckboxCustomization';
import { FileCustomization } from './FileCustomization';
import { TextFieldCustomization } from './TextFieldCustomization';

interface CustomizationFieldProps {
    customizationsState: CustomizationsState;
    customization: Customization;
    filestackConfig: PCFileStackConfig;
    styles?: ProductCustomizationsStyles;
    previewAllSelected?: boolean;
}

const CustomizationField = ({
    customizationsState,
    customization,
    styles,
    filestackConfig,
    previewAllSelected,
}: CustomizationFieldProps) => {
    switch (customization.type) {
        case CustomizationType.FILE:
            if (!featureFlags.getBoolean('runtime.ssr.file.customizations')) {
                return null;
            }

            return (
                <FileCustomization
                    {...customization}
                    key={customization.id}
                    styles={styles}
                    error={customizationsState.errors[customization.id]}
                    onChange={customizationsState.updateValue}
                    validateField={customizationsState.validate}
                    filestackConfig={filestackConfig}
                />
            );
        case CustomizationType.TEXT:
            return (
                <TextFieldCustomization
                    {...customization}
                    key={customization.id}
                    styles={styles}
                    value={
                        customizationsState.values[customization.id] as string
                    }
                    error={customizationsState.errors[customization.id]}
                    onChange={customizationsState.updateValue}
                    validateField={customizationsState.validate}
                />
            );
        case CustomizationType.CHECKBOX:
            return (
                <CheckboxCustomization
                    {...customization}
                    key={customization.id}
                    styles={styles}
                    value={
                        customizationsState.values[customization.id] as string[]
                    }
                    error={customizationsState.errors[customization.id]}
                    previewAllSelected={previewAllSelected}
                    onChange={customizationsState.updateValue}
                    validateField={customizationsState.validate}
                />
            );
        default:
            return null;
    }
};

export default observer(CustomizationField);
